import CheckDepositAgreementsScreen from 'features/rdc/screens/Agreements/Agreements';
import React from 'react';

export default function CheckDepositAgreementsPage() {
  return <CheckDepositAgreementsScreen />;
}
